import React from "react"

import { User, Address, DigitPermission } from "@gql/graphql"

export type OrganizationType = {
  addresses: Address[]
  defaultCurrency: {
    code: string
    id: string
    symbol: string
  }
  hasActiveAccountingIntegration: boolean
  id: string
  clerkOrganizationId: string
  logo: string | null
  name: string
  replyToEmail?: string | null

  moduleSettings: {
    shipping: {
      preventOverPicking: boolean
    }
    receiving: {
      preventOverReceiving: boolean
    }
  }
}

type SettingsData = {
  language: string
  starredFeatures: {
    edges: Array<{
      node: {
        id: string
        name: string
      }
    }>
  }
  viewMode: string
}

export type RoleDetails = {
  id: string
  name: string
  displayName: string
  description: string | null
}

export type ProfileData = {
  about: string | null
  email: string
  firstName: string | null
  fullName: string | null
  id: string
  image: string | null
  lastName: string | null
  role: RoleDetails
  status: string | null
  firstLogin?: string | null
}

export type OrgMemberType = {
  id: string | null
  settings: SettingsData
  profile: ProfileData
}

export type SessionContextType = {
  currentUser: User | null | undefined
  currentPermissions: Set<DigitPermission> | null | undefined
  org: OrganizationType | null | undefined
  orgMember: OrgMemberType | null | undefined
  refetchSession: () => void
}

const SessionContext = React.createContext<SessionContextType>({
  currentUser: null as User | null | undefined,
  currentPermissions: null as Set<DigitPermission> | null | undefined,
  org: null as OrganizationType | null | undefined,
  orgMember: null as OrgMemberType | null | undefined,
  refetchSession: () => {},
})

export default SessionContext
